export default {"src":"/_next/static/media/website.41db90b2.svg","height":26,"width":25,"blurWidth":0,"blurHeight":0};